import { memo, useContext, useState } from "react";
import Input from "../../components/input/input";
import styles from '../loginSignup.module.css';
import Button from "../../components/button/button";
import { useNavigate } from "react-router-dom";
import { getUserData, loginAPI } from "../../services/api";
import { UserDataContext } from "../../Context/Context";
export default memo(function LoginComponent({frogotFunc, signUpFunc }) {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [apiError, setApiError] = useState(false);
    const [click, setClick] = useState(false);
    const { setUser } = useContext(UserDataContext);
    const navigate = useNavigate();

    const loginAuth = async () => {
        setApiError(false)
        setClick(true)
        let signIn = await loginAPI(email, password)
        if (signIn.ok) {
            const result = await getUserData();
            const resultUser = result?.user || { username: signIn.data?.userName || "", email };
            setUser({ ...resultUser, loggined: true })
            navigate('/');
        } else {
            setApiError(true)
            setClick(false)
        }
    };
    return (
        <>
            <h2>Hi! Let’s get you signed in.</h2>
            <div className={styles.inputcontainer}>
                <Input
                    id="email"
                    label="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={(email?.length > 0 && (!email || !email.includes('@'))) ? { border: '1px solid red' } : null}
                    errText={!email.includes('@') && email?.length > 0 ? 'Please enter a valid email address.' : null}
                />
                <Input
                    id="password"
                    label="Password"
                    value={password}
                    type="password"
                    onChange={(e) => setPassword(e.target.value)}
                    style={password?.length > 0 && password?.length < 8 ? { border: '1px solid red' } : null}
                    errText={password?.length > 0 && password?.length < 8 ? 'Password must be at least 8 characters.' : null}
                />
                <p onClick={frogotFunc}> <span className={styles.forgotPass} >Forgot your password</span>?</p>
                <div style={{ marginTop: '50px' }}>
                    {apiError && <p style={{ color: 'red', margin: '10px 0' }}>Incorrect username or password. Please try again.</p>}
                    <Button onClick={() => loginAuth()} children={'Log In'} style={{ margin: '0' }} disabled={!email || !password || !email.includes('@') || password?.length < 8 || click} />
                </div>
            </div>
            <p style={{ marginTop: '10px', fontSize: '14px' }}>Don’t have an account?  <span onClick={signUpFunc} style={{ cursor: 'pointer', textDecoration: 'underline' }}>Sign up</span></p>
            <p style={{ marginTop: '10px', fontSize: '14px' }}>Trouble logging on? <span onClick={() => navigate('/support')} style={{ cursor: 'pointer', textDecoration: 'underline' }}>Contact support.</span></p>
        </>
    )
})
